import {
	LOAD_SCREEN,
	SCREEN_LOADED,
	FILTERS_LOADED,
	TABLE_VIEWS_LOADED,
	DELETE_TABLE_VIEW,
	LOAD_TRANSACTIONS,
	TRANSACTIONS_LOADED,
	BULK_UPDATE_TRANSACTIONS,
	BULK_UPDATE_TRANSACTIONS_COMPLETE,
	CLEAR_TRANSACTIONS,
	LOAD_USERS,
	LOAD_CALENDARS,
	USERS_LOADED,
	CALENDARS_LOADED,
	FETCH_RECORD_IDS,
	LOAD_RECORD_IDS,
	CLEAR_RECORD_IDS,
	SCREEN_LOADING,
	TRANSACTIONS_UPDATED,
	MARK_TASK_COMPLETED,
	CREATE_OR_UPDATE_TABLE_VIEW,
	KANBAN_TRANSACTIONS_LOADED,
	LOAD_MORE_TRANSACTIONS,
	LOAD_ACTIVITIES_SCREEN_FILTERS,
	SET_LOADER,
} from "./constants";

// Load Screen Actions
export function loadScreen(moduleName, screenType, moduleGroup) {
	return { type: LOAD_SCREEN, moduleName, screenType, moduleGroup };
}

export function screenLoaded(screenData) {
	return { type: SCREEN_LOADED, screenData };
}

export function activitiesFiltersLoaded(filters) {
	return { type: FILTERS_LOADED, filters };
}

export function loadActivitiesScreenFilters(moduleName) {
	return { type: LOAD_ACTIVITIES_SCREEN_FILTERS, moduleName };
}

// Load Transaction Records for the table
export function loadTransactions(
	screenName,
	formId,
	search,
	filters,
	sorted,
	page,
	pageSize,
	usersToFetch,
	view,
	startDate,
	endDate,
	pipeline,
	recordStatus,
	stage,
	taskType,
) {
	return {
		type: LOAD_TRANSACTIONS,
		screenName,
		formId,
		search,
		filters,
		sorted,
		page,
		pageSize,
		usersToFetch,
		view,
		startDate,
		endDate,
		pipeline,
		recordStatus,
		stage,
		taskType,
	};
}

export function transactionsLoaded(data) {
	return { type: TRANSACTIONS_LOADED, data };
}

// Bulk Update Transactions
export function bulkUpdateTransactions(data) {
	return { type: BULK_UPDATE_TRANSACTIONS, data };
}

export function bulkUpdateTransactionsCompleted(complete) {
	return { type: BULK_UPDATE_TRANSACTIONS_COMPLETE, complete };
}

export function clearTransactions() {
	return {
		type: CLEAR_TRANSACTIONS,
	};
}

export function loadUsers() {
	return {
		type: LOAD_USERS,
	};
}

export function loadCalendars() {
	return {
		type: LOAD_CALENDARS,
	};
}

export function usersLoaded(users) {
	return { type: USERS_LOADED, users };
}

export function calendarsLoaded(calendars) {
	return { type: CALENDARS_LOADED, calendars };
}

// Fetch Transaction RecordIds
export function fetchRecordIds(screenName, moduleId, formId, search, filters) {
	return {
		type: FETCH_RECORD_IDS,
		moduleId,
		formId,
		search,
		filters,
		screenName,
	};
}

export function loadRecordIds(data) {
	return {
		type: LOAD_RECORD_IDS,
		data,
	};
}

export function clearRecordIds() {
	return {
		type: CLEAR_RECORD_IDS,
		data: [],
	};
}

export function setScreenLoading(loading) {
	return {
		type: SCREEN_LOADING,
		loading,
	};
}

export function updateRecordInTransactions(records, oldRecords) {
	const newRecords = [...oldRecords];
	const recIndex = oldRecords.findIndex(oldRec => oldRec._id === records.id);

	if (recIndex !== -1) {
		let newRecord = { ...records };
		newRecord._id = records.id;
		delete newRecord.id;

		if (
			newRecord.activityType === "TASK" &&
			newRecords[recIndex].records &&
			newRecords[recIndex].records.F157 &&
			Object.keys(newRecords[recIndex].records.F157).length
		) {
			newRecord = {
				...newRecord,
				records: {
					...newRecord.records,
					F157: newRecords[recIndex].records.F157,
				},
			};
		}

		newRecords[recIndex] = newRecord;
	}

	return { type: TRANSACTIONS_UPDATED, data: { transactions: newRecords } };
}

export function createRecordInTransactions(
	record,
	oldRecords,
	recordsTotal,
	pageSize,
) {
	record._id = record.id;
	delete record.id;
	const newRecords = [record, ...oldRecords];
	if (newRecords.length > pageSize) {
		newRecords.pop();
	}
	return {
		type: TRANSACTIONS_LOADED,
		data: {
			transactions: newRecords,
			recordsTotal: recordsTotal + 1,
			recordsFiltered: newRecords.length,
			loading: false,
		},
	};
}

// * Mark Task Update - Listing Page
export function markTaskAsComplete(id, status, transactionId) {
	return {
		type: MARK_TASK_COMPLETED,
		id,
		status,
		transactionId,
	};
}

/**
 * table view actions
 */
// create or Update TableView
export function createOrUpdateTableView(type, data, visualType) {
	return {
		type: CREATE_OR_UPDATE_TABLE_VIEW,
		data: { type, data, visualType },
	};
}

export function tableViewsLoaded(viewsData) {
	return { type: TABLE_VIEWS_LOADED, viewsData };
}

// Delete Table View
export function deleteTableView(viewId, screenId, visualType) {
	return { type: DELETE_TABLE_VIEW, viewId, screenId, visualType };
}

export function kanbanTransactionsLoaded(data) {
	return { type: KANBAN_TRANSACTIONS_LOADED, data };
}
export function loadMore(
	screenName,
	formId,
	search,
	filters,
	sorted,
	usersToFetch,
	view,
	startDate,
	endDate,
	pipeline,
	recordStatus,
	stage,
	recordsFetched,
	taskType,
) {
	return {
		type: LOAD_MORE_TRANSACTIONS,
		screenName,
		formId,
		search,
		filters,
		sorted,
		usersToFetch,
		view,
		startDate,
		endDate,
		pipeline,
		recordStatus,
		stage,
		recordsFetched,
		taskType,
	};
}
// added action to set loader
export function loaderAction(flag = true) {
	return {
		type: SET_LOADER,
		flag,
	};
}
